// extracted by mini-css-extract-plugin
export default {"container":"notification__container___t2sG8","isShown":"notification__isShown___lzrYB","closeIcon":"notification__closeIcon___hAYH5"};